import React from 'react';

// Placeholder shown exactly as supplied in the design reference; replace with the real name.
const ACCOUNTANT_NAME = '[Accountant name]';

const MESSAGES = [
  { from: 'client', text: 'Sending September receipts 📎 14 files' },
  { from: 'accountant', text: 'Got all 14, thanks. Two card payments on the 18th have no invoice. Can you forward them?' },
  { from: 'client', text: 'Done, just emailed both.' },
  { from: 'accountant', text: 'Perfect. September is reconciled. Report comes on the 10th ✅' },
];

const CADENCE = [
  { day: 'Day 1–3', text: 'You send receipts and statements on WhatsApp or email.' },
  { day: 'Day 4–7', text: 'We reconcile bank, cards, payables and receivables.' },
  { day: 'Day 8–9', text: 'A second accountant reviews VAT treatment.' },
  { day: 'Day 10', text: 'Your P&L, balance sheet and VAT position, delivered.', highlight: true },
];

const ChatWindow = () => (
  <figure className="bk-chat" aria-label="Example WhatsApp conversation with your accountant">
    <figcaption className="bk-chat-head">
      <span className="bk-chat-name">{ACCOUNTANT_NAME} · Standard Auditors</span>
      <span className="bk-chat-status">Your accountant · usually replies in minutes</span>
    </figcaption>
    <ol className="bk-chat-body">
      {MESSAGES.map((m) => (
        <li key={m.text} className={`bk-bubble bk-bubble--${m.from === 'client' ? 'out' : 'in'}`}>
          {m.text}
        </li>
      ))}
    </ol>
  </figure>
);

const WhatsAppSection = () => (
  <section className="bk-wa" id="protocol" data-screen-label="How It Works">
    <div className="bk-container bk-wa-grid">
      <ChatWindow />

      <div className="bk-wa-copy">
        <span className="bk-eyebrow bk-eyebrow--light">How it works</span>
        <h2 className="bk-wa-title">Bookkeeping in Dubai, done over WhatsApp.</h2>

        <ol className="bk-cadence">
          {CADENCE.map((row) => (
            <li key={row.day} className={`bk-cadence-row ${row.highlight ? 'is-final' : ''}`}>
              <span className="bk-cadence-day"><span>{row.day}</span></span>
              <span className="bk-cadence-text">{row.text}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default WhatsAppSection;
